/* eslint-disable */
export default {
  unknown: 'Desconocido',
  anonymous: 'Anónimo',
  activeCalls: 'Todas las llamadas',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"activeCalls"@#@ @source: @#@"All Calls"@#@
